import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { RootCloseWrapper } from 'react-overlays';
import {colorToHex} from '../api/color';

class Itemname extends Component {
  render() {
    const color = {
      color: this.props.color
    }
    return (
      <div className = "item-name" style={color} >
          {this.props.children}
      </div>
    );
  }
}

class CustomToggle extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <div className="dropdown-btn" onClick={this.handleClick}>
        {this.props.children}
      </div>
    );
  }
}

class CustomMenu extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleChange = this.handleChange.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.filterChildren = this.filterChildren.bind(this);
    this.state = {
      value: '',
    };
  }

  selectAll(){
    this.props.selectAllFilters(this.props.filterTitle.en);
  }

  deselectAll(){
    this.props.deselectAllFilters(this.props.filterTitle.en);    
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  filterChildren(child) {
    let {name} = child.props.children.props.children[0].props.children.props.children.props;
    let {value} = this.state;
    if(!value.trim()) return true;
    else if (name.indexOf(value) !== -1) return true;  
    else return false;
  }

  render() {
    const { children } = this.props;
    const { value } = this.state;

    return (
      <div className="dropdown-menu">
        <input ref={c => {this.input = c;}} type="text" placeholder="جستجو" onChange={this.handleChange} value={value || ''}/>
        <ul className="project-list">
            { !this.state.value ? (<MenuItem className="filter-controller" onClick={this.selectAll} > انتخاب همه </MenuItem>) : (null)  }
            { !this.state.value ? (<MenuItem className="filter-controller" onClick={this.deselectAll}  > پاک کردن انتخاب ها </MenuItem>) : (null)  }
            { !this.state.value ? (<MenuItem header className='filter-header' >  {this.props.filterTitle.header}  </MenuItem>) : (null)  }
            {React.Children.toArray(children).filter(
              child => this.filterChildren(child)
            )}
        </ul>
      </div>
    );
  }
}

export class DropdownFilter extends Component {
  constructor(props, context) {
    super(props, context); 
    this.state = {
      open: false
    };
    this.handleClick = this.handleClick.bind(this)   
    this.toggleOpenState = this.toggleOpenState.bind(this)   
    this.setOpenStateToFalse = this.setOpenStateToFalse.bind(this)   
  }
  
  setOpenStateToFalse() {
    this.setState({open : false});
  }

  toggleOpenState() {
    this.setState({open : !this.state.open});
  }

  handleClick(filterType,filterItem,compareAttr) {
    this.props.applyFilter({filterType,filterItem,compareAttr});
  }

  render(){
    // const { project } = this.props.selected ;
    let {filterTitle} = this.props;
    let filterNumber = this.props.report[filterTitle.en+'_filters_number'];
    let filterList;
    if(this.props.report.paginationConfig.query[filterTitle.en] && this.props.report.paginationConfig.query[filterTitle.en].length>0) {
      filterList = this.props.report.paginationConfig.query[filterTitle.en].map((p) => (
        <MenuItem className="item-box" eventKey={p[filterTitle.attr]} key={p[filterTitle.attr]} onClick={() => {this.handleClick(filterTitle.en,p,filterTitle.attr)} } >
          <div className="row">
            <div className="col-sm-2 checkbox">
              <label><input type="checkbox" checked={p.is_checked || false} name={p.name} /></label>
            </div>
            <div className="col-sm-10 itemname-container ">
              <Itemname color={ p.color ? ( colorToHex(p.color) ) : ('#0f0f0f') }>{p.name.trunc(20)}</Itemname>
            </div>
          </div>
        </MenuItem>
      ));
    }

    return (
    <RootCloseWrapper onRootClose={this.setOpenStateToFalse}>
      <Dropdown open={this.state.open} onToggle={this.toggleOpenState} id="dropdown-custom-menu">
        <CustomToggle bsRole="toggle">
          {filterTitle.fa}                              
          <span className="caret" > 
            { filterNumber>0 ?  (<span className="badge" > {filterNumber}  </span>) : ('')}  
          </span>
        </CustomToggle>

        <CustomMenu filterTitle={filterTitle} bsRole="menu" {...this.props} >
          {filterList}
        </CustomMenu>
      </Dropdown>
    </RootCloseWrapper>)
  }
}